import { Navigate, useParams } from 'react-router';

export function UserProfileRedirect() {
  const { id } = useParams();
  return <Navigate to={`/profile/${id}`} />;
}

export function MatchRedirect() {
  const { id } = useParams();
  return <Navigate to={`/match/${id}`} />;
}

export function ScrimMatchRedirect() {
  const { id } = useParams();
  return <Navigate to={`/scrim/${id}`} />;
}

export function FinderRedirect() {
  return <Navigate to={`/team-finder`} />;
}

export function ScrimRedirect() {
  return <Navigate to={`/server`} />; // TODO: Revert to scrim-finder
}
